import { HttpService } from '@/infra/http'
import type { TGetDetalhesProdutoBaseResponse } from '@/types/produto'

export type TGetDetalhesLoteResponse = Omit<
  TGetDetalhesProdutoBaseResponse,
  'blocoId' | 'unidadeDeNegocioId' | 'codigo'
> & {
  quadra: string
  valor: number
  idExternoBloco: number
  reserva?: {
    dataExpiracao: string
    nomeResponsavel: string
    emailResponsavel: string
    idResponsavel: string
  }
}

export class GetDetalhesLoteService extends HttpService {
  execute = async (idExterno: number) => {
    return this.http.get<TGetDetalhesLoteResponse>(`/api/v2/Produto/lote/${idExterno}/detalhes`)
  }
}
